export default "__VITE_ASSET__CF5n0xU9__"